import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useAuth } from './auth-context'

const STORAGE_PREFIX = 'isfet-admin-demo-mode:'

const DemoModeContext = createContext({
	demoMode: false,
	setDemoMode: () => {},
	redactionActive: false,
})

export function DemoModeProvider({ children }) {
	const { user, isAdmin, isAllScope } = useAuth()
	const storageKey = user?.id ? `${STORAGE_PREFIX}${user.id}` : null
	const [stored, setStored] = useState(() => {
		try {
			if (!user?.id) return false
			return localStorage.getItem(`${STORAGE_PREFIX}${user.id}`) === 'true'
		} catch {
			return false
		}
	})

	useEffect(() => {
		if (!storageKey) {
			setStored(false)
			return
		}
		try {
			setStored(localStorage.getItem(storageKey) === 'true')
		} catch {
			setStored(false)
		}
	}, [storageKey])

	const setDemoMode = useCallback(
		(next) => {
			if (!isAdmin || !storageKey) return
			const b = Boolean(next)
			setStored(b)
			try {
				localStorage.setItem(storageKey, b ? 'true' : 'false')
			} catch {
				// ignore quota / private mode
			}
		},
		[isAdmin, storageKey]
	)

	const redactionActive = Boolean(isAdmin && stored && !isAllScope)
	const demoModeForUi = isAdmin ? stored : false

	const value = useMemo(
		() => ({
			demoMode: demoModeForUi,
			setDemoMode,
			redactionActive,
		}),
		[demoModeForUi, setDemoMode, redactionActive]
	)

	return <DemoModeContext.Provider value={value}>{children}</DemoModeContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useDemoMode() {
	return useContext(DemoModeContext)
}
